
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offshore",
      function () {
        return require("private-next-pages/offshore/index.js");
      }
    ]);
  